import { PCA } from 'ml-pca';
/**
 * Estimate the number of pure components of each range by NIPALS PCA.
 * @param chromatogram - GC/MS chromatogram where make the estimation.
 * @param options - Options with range and the matrix.
 */
export function estimateNbPureComponents(chromatogram, options) {
    const { range } = options;
    let { matrix } = options;
    if (!matrix)
        matrix = chromatogram.getMzVsTimesMatrix(range).matrix;
    const pca = new PCA(matrix, {
        method: 'NIPALS',
        nCompNIPALS: 10,
        scale: true,
        ignoreZeroVariance: true,
    });
    const s = pca.getExplainedVariance();
    let rank = 1;
    let cumulative = s[0];
    while ((cumulative - s[rank]) / cumulative < 0.88 && rank < s.length) {
        cumulative += s[rank];
        rank++;
    }
    return rank;
}
//# sourceMappingURL=estimate_nb_pure_components.js.map